import React from "react";
import {logOutSession} from "../../../requests/AppSession";
import {useAuth} from "@workos-inc/authkit-react";
import {ArrowLeftEndOnRectangleIcon} from "@heroicons/react/20/solid";

const LogoutButton = () => {
    const {signOut} = useAuth();

    return (
        <button
            type="button"
            onClick={() => {
                logOutSession();
                signOut({returnTo: window.location.origin})
            }}
            className="-m-3 w-full cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
        >
            <div
                className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                <ArrowLeftEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
            </div>
            <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Log Out</div>
        </button>
    );
};

export default LogoutButton;
